import ReportsView from "./reports-view";

const AdminReportsView = () => {
  return (
    <ReportsView page="admin" />
  )
}

export default AdminReportsView